import { AdminApi } from "../index";

// 코인 출금
export async function coinWithdraw(body: CoinWithdrawReqBody) {
  return AdminApi.post("/coin-withdraw", body).then((resp) => resp.data);
}